.barStyle {
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background-color: var(--color-gray-800);
    color: white;
    padding: 10px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
    box-shadow: black 0 0 10px;
}

.button{
    cursor: pointer;
}

.date{
    cursor: pointer;
    user-select: none;
}

.today {
    color: var(--color-blue-violet-minilight);
}